module.exports = __webpack_public_path__ + "static/img/slsPurpose1.2804de9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slsPurpose1.png
// module id = e1ae
// module chunks = 2